<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PYBNAo/tc-custom/9780830853014.jpg?1696024558559" alt="This image is the cover for the book Does God Exist?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Does God Exist?
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Does God exist?</strong> </p> <p>Throughout the history of philosophical and theological reflection, this fundamental question has prompted a range of responses.</p> <p>In one incisive volume, philosopher W. David Beck offers a narrative of pre-Christian, Jewish, Buddhist, Christian, and Islamic arguments for God's existence. Here, readers will encounter both classical and contemporary arguments, including cosmological, teleological, moral, and ontological arguments along with commentary from the author.</p> <p>Explore the history of answers to an essential question and add your own reflections to this ongoing conversation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. David Beck
      </h2>
      
      <p class="authorDescription body article"><p>W. David Beck (PhD, Boston University) is emeritus professor of philosophy at Liberty University. He is the coeditor of <em>Raised on the Third Day: Defending the Historicity of the Resurrection of Jesus</em>, and his written work has appeared in publications including <em>Philosophia Christi</em>, <em>Journal of the Evangelical Theological Society</em>, and <em>Christianity Today</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b820a7a2